import { useMemo } from 'react';
import { getRatingLabels } from '../utils/FeedbackUtils';
// @ts-ignore this isn't typescript yet
import { CES, NPS, CSAT } from 'feedback-schema/constants/surveyTypes';
import CesRating from 'feedback-shared-ui/ratings/Ces';
// @ts-ignore this isn't typescript yet
import CsatRating from 'feedback-shared-ui/ratings/Csat';
// @ts-ignore this isn't typescript yet
import NpsRating from 'feedback-shared-ui/ratings/Nps';
import { jsx as _jsx } from "react/jsx-runtime";
const SurveyTypeComponents = {
  [NPS]: NpsRating,
  [CES]: CesRating,
  [CSAT]: CsatRating
};
export const RatingInputs = ({
  device,
  surveyType,
  rating,
  setRating,
  surveyConfig
}) => {
  const labels = useMemo(() => getRatingLabels(surveyConfig.strings, surveyType, device), [surveyConfig, surveyType, device]);
  const Component = useMemo(() => SurveyTypeComponents[surveyType], [surveyType]);
  const isCsat = useMemo(() => surveyType === CSAT, [surveyType]);
  const props = Object.assign({
    device,
    value: rating,
    onChange: setRating,
    lowRangeLabel: labels.low,
    highRangeLabel: labels.high
  }, isCsat && {
    size: 55,
    spacing: 8
  });
  if (!Component) return null;
  return /*#__PURE__*/_jsx(Component, Object.assign({}, props));
};